@for (tick of ticks; track tick) {
  <svg:line
    class="grid-ver"
    [attr.x1]="scale(tick)"
    [attr.x2]="scale(tick)"
    [attr.y1]="0"
    [attr.y2]="dimensions.boundedHeight"
    ></svg:line>
  }
